import { render } from "./SlotCard.vue?vue&type=template&id=0798710c"
import script from "./SlotCard.vue?vue&type=script&lang=js"
export * from "./SlotCard.vue?vue&type=script&lang=js"

import "./SlotCard.vue?vue&type=style&index=0&id=0798710c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__